import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveTipoVeiculo(tipo) {
  try {
    const response = await authHttp().post(routes.urlPostTipoVeiculo, tipo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTiposVeiculos() {
  try {
    const response = await authHttp().get(routes.urlGetTipoVeiculo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
